import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { MuiSwitchStyled } from './styles';

const Switch = ({ textColor, label, onChange, checked }) => (
  <Stack
    alignItems="center"
    direction="row"
    spacing="4px"
  >
    <MuiSwitchStyled
      checked={checked}
      inputProps={{ 'aria-label': label }}
      onChange={onChange}
    />
    <Text
      color={textColor}
      size="xs"
      weight="medium"
    >
      {label}
    </Text>
  </Stack>
);

Switch.propTypes = {
  textColor: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func
};

export default Switch;
